import { useEffect } from 'react';

/**
 *  Adds and removes a className from the document body.
 *
 * @param {String} className A class name you want to add to the document body.
 * @returns {void}
 */
const useBodyClass = (className?: string): void => {
  useEffect(() => {
    if (!className) {
      return;
    }
    // Add a class to the body.
    document.body.classList.add(className);

    return () => {
      // Remove the class from the body.
      document.body.classList.remove(className);
    };
  }, [className]);
};

export default useBodyClass;
